// 唤起广告工具客户端(监播截图下载,生成上刊报告ppt等功能)
export const EvokeAdvClient = 'zladvutil://startMonitorDownload/'

// 需客户状态为"生效中"才能使用的菜单页编码/路由name集合(点位投放、地图投放、网络广告投放、实时广告投放)
export const SpecialPageCode = ['DWTF', 'DTTF', 'WLGGTF', 'SSGGTF']

// 素材类型映射
export const materialType2name = {
  0: '未知',
  1: '视频',
  2: '图片',
  3: '文字',
  4: 'wifi',
  5: 'H5',
  /**
   * @deprecated 流地址，已废弃
   */
  6: '文件流',
  7: '普通拉流地址',
  8: 'HLS拉流地址',
  9: 'RTMP拉流地址',
  10: 'HDL拉流地址',
  11: 'DASH拉流地址'
}

// 河南新再灵科技有限公司下属相关用户,“点位投放”可使用 CPD/CPR(按天)/CPR(按流量)
export const HeNanIds = [
  14896, // 13683800527
  15437, // 18037117720
  14889, // 18538009966
  14493 // 13140013931
]

// 河南新再灵(郑州)用户,限制“地图投放”、“限量广告”、“对比报告”不可见,“点位投放”可使用 CPD/CPR(按天)/CPR(按流量)
export const ZhengZhouMode = [
  2003208, // 13014692022
  2003209, // 18310111071
  2003233 // 17317598392 上海再灵
]
